import { PaginatedResponse } from './Client.types';
import isObject from 'lodash/isObject';

const isPaginatedResponse = <T>(data: any): data is PaginatedResponse<T> => {
  return isObject(data) && 'items' in data && 'meta' in data;
};

export { isPaginatedResponse };
